module.exports = __webpack_public_path__ + "static/media/mail-accent.6ca75a0f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mail-accent.svg
// module id = 673
// module chunks = 0